import { render, staticRenderFns } from "./project_formsub.vue?vue&type=template&id=4a4a0f20&scoped=true"
import script from "./project_formsub.vue?vue&type=script&lang=js"
export * from "./project_formsub.vue?vue&type=script&lang=js"
import style0 from "./project_formsub.vue?vue&type=style&index=0&id=4a4a0f20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4a0f20",
  null
  
)

export default component.exports